import { DataProvider } from 'react-admin';

export default (type: string) => {
  let dataProviderPromise = getDataProvider(type);

  let param1 = {
    sort: {
      field: 'clientname',
      order: 'ASC',
    },
  };
  const dataProviderWithGeneratedData = new Proxy(defaultDataProvider, {
    get(_, name) {
      if (name === 'supportAbortSignal') {
        return true;
      }
      return (resource: string, params: any) => {
        return dataProviderPromise.then((dataProvider) => {
          return dataProvider[name.toString()](resource, params).catch((error: any) => {
            const isAborted =
              error.name === 'AbortError' ||
              error.message?.includes('aborted') ||
              error.message?.includes('signal is aborted');

            if (isAborted) {
              return { data: [], total: 0 };
            }
            throw error;
          });
        });
      };
    },
  });

  return dataProviderWithGeneratedData;
};

const getDataProvider = async (type: string): Promise<DataProvider> => {
  if (type === 'graphql') {
    return import('./graphql').then((factory) => factory.default());
  }
  return import('./rest').then((provider) => provider.default);
};

const defaultDataProvider: DataProvider = {
  // @ts-ignore
  create: () => Promise.resolve({ data: { id: 0 } }),
  // @ts-ignore
  delete: () => Promise.resolve({ data: {} }),
  deleteMany: () => Promise.resolve({}),
  getClaims: () => Promise.resolve({ data: [], total: 0 }),
  getMany: () => Promise.resolve({ data: [] }),
  getManyReference: () => Promise.resolve({ data: [], total: 0 }),
  // @ts-ignore
  getOne: () => Promise.resolve({ data: {} }),
  // @ts-ignore
  update: () => Promise.resolve({ data: {} }),
  updateMany: () => Promise.resolve({}),
};
